import { Dialog, DialogModule } from "@angular/cdk/dialog";
import { CommonModule } from "@angular/common";
import { Component, EventEmitter, HostBinding, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { ButtonConfig, Client, Job, VoyseComponent } from "@interfaces";
import { GtagService } from "src/app/containers/gtag/gtag.service";
import { ApplyFormComponent } from "src/app/dialogs/application-dialog/apply-form/apply-form.component";
import { GreenhouseApplicationComponent } from "src/app/dialogs/application-dialog/greenhouse-application/greenhouse-application.component";
import { LeadDialogComponent } from "src/app/dialogs/lead-dialog/lead-dialog/lead-dialog.component";
import { calculateButtonClasses, calculateButtonStyle } from "src/app/helpers/buttons";
import { SubdomainService } from "src/app/rest/subdomain.service";

@Component({
    selector: "app-apply-button",
    standalone: true,
    imports: [CommonModule, DialogModule],
    templateUrl: "./apply-button.component.html",
    styleUrls: ["./apply-button.component.css"],
})
export class ApplyButtonComponent implements OnInit {
    @Output() onClick = new EventEmitter();
    @Input() component: VoyseComponent;
    @Input() buttonConfig: ButtonConfig;
    @Input() job: Job;
    @Input() buttonSize = "medium";
    @Input() public buttonClasses = [];
    public client: Client;
    public buttonStyle = {};

    constructor(
        private dialog: Dialog,
        private subdomain: SubdomainService,
        protected gtag: GtagService,
    ) {
        this.subdomain.getClient().subscribe((client: Client) => {
            this.client = client;
        });
    }

    @HostBinding("class.w-full") fullWidth = false;

    ngOnInit() {
        this.buttonStyle = calculateButtonStyle(this.buttonConfig, this.client);
        this.buttonClasses = [...this.buttonClasses, ...calculateButtonClasses(this.buttonConfig)];
        if (this.buttonConfig?.fullWidth) {
            this.fullWidth = true;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['buttonConfig']) {
            this.buttonStyle = calculateButtonStyle(this.buttonConfig, this.client);
            this.buttonClasses = [...this.buttonClasses, ...calculateButtonClasses(this.buttonConfig)];
        }
    }

    public apply() {
        this.onClick.emit();
        if (!this.job?.active) {
            this.openLeadDialog();
        } else if (this.job?.thirdPartyJob?.vendor === "greenhouse" && !this.job?.thirdPartyJob?.useInternalATS) {
            this.openGreenhouseApplyDialog();
        } else {
            this.openApplyDialog();
        }
    }

    public onThirdPartyApply() {
        this.onClick.emit();
        this.gtag.fireOpenJobDialogEvent(this.job?._id, this.job?.title);
    }

    public openLeadDialog() {
        this.subdomain.getClient().subscribe((client: Client) => {
            this.dialog.open(LeadDialogComponent, {
                width: "750px",
                maxWidth: "95vw",
                maxHeight: "85vh",
                panelClass: "low-padding-dialog",
                data: {
                    client,
                    job: this.job,
                    captureJobIntent: false,
                    captureCV: true,
                },
            });

            this.gtag.fireOpenJobDialogEvent(this.job?._id, this.job?.title);
        });
    }

    public openApplyDialog() {
        this.gtag.fireOpenApplyDialogEvent(this.job?._id, this.job?.title);

        this.dialog.open(ApplyFormComponent, {
            height: "auto",
            maxHeight: "90vh",
            data: {
                job: this.job,
                component: this.component,
            },
        });
    }

    public openGreenhouseApplyDialog() {
        this.gtag.fireOpenApplyDialogEvent(this.job?._id, this.job?.title);
        this.dialog.open(GreenhouseApplicationComponent, {
            width: "600px",
            maxWidth: "90vw",
            height: "800px",
            autoFocus: false,
            data: {
                jobId: this.job?.thirdPartyJob.vendorId,
                jobTitle: this.job?.title,
                voyseJobId: this.job?._id,
            },
        });
    }
}
